
import { ActionT } from '../../../framework/framework/components/Types';
import TrashIcon from '../../../framework/framework/shared/icons/TrashIcon';
import { IBasketItem } from '../../../services/productService/models/IBasketItem';
import * as style from './style.css';
import NumberInput from '../../../components/numberInput/NumberInput';
import React = require('react');

interface IProps {
    itemUri: string;
    item: IBasketItem;
    onUpdateItem: ActionT<IBasketItem>;
    onRemoveItem: ActionT<IBasketItem>;

}
interface IState { }

export default class BasketItem extends React.Component<IProps, IState> {
    render() {
        const i = this.props.item;
        return (
            <div className={style.item} key={i.productId}>
                <div className={style.image} key={1}>
                    <div className={style.imageWrapper}>
                        <a href={this.props.itemUri}>
                            <img src={i.thumbnail + '/100'}></img>
                        </a>
                    </div>
                </div>
                <div className={style.content} key={2}>
                    <div className={style.title}>
                        <div className={style.name}>
                            <a href={this.props.itemUri}>
                                {i.name}
                            </a>
                            <div>
                                Kod towaru:{i.productId}
                            </div>
                        </div>
                    </div>
                    <div className={style.itemAction} key={'action'}>

                        <div className={style.qty} key={3}>
                            <NumberInput
                                value={i.quantity}
                                onChange={v => this.updateQty(v)}
                            />
                        </div>
                        <div className={style.total}>
                            {i.price.toFixed(2)}

                        </div>
                        <div className={style.trash}>
                            <TrashIcon onClick={() => this.props.onRemoveItem(i)} />
                        </div>
                    </div>
                </div>

            </div >
        );
    }

    updateQty(qty: number) {
        if (qty <= 0) { return; }
        const item = this.props.item;
        item.quantity = qty;
        this.props.onUpdateItem(item);
    }

    onQtyChange(e: React.ChangeEvent<HTMLInputElement>): void {
        const value = e.target.value;
        const qty = parseFloat(value);
        if (Number.isNaN(qty)) { return; }
        this.updateQty(qty);
    }
}
